import React, { useState, useEffect } from "react";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { useLocation, useNavigate } from "react-router-dom";
import Cliam from "./Cliam";
import ClaimSuccess from "./ClaimSuccess";

const AuthConsider = () => {
  const { makeApiRequest } = useApiRequest();
  const [loader, setLoader] = useState(false);
  const [digitalorderData, setDigitalOrderData] = useState();
  const [claimedFlag, setClaimFlag] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const isClaimed = params.get("claim") === "true";
  const lineitemid = params.get("lineitemid");
console.log("lineitemid",lineitemid)
  /* ---------------------------------- */
  /* 🔹 CHECK URL PARAMS ON LOAD */
  /* ---------------------------------- */

  useEffect(() => {
    DigitalOrders();

    if (isClaimed && lineitemid) {
        ClaimdigitalOrder(lineitemid)
      setClaimFlag(true);
    }
  }, [isClaimed, lineitemid]);

  /* ---------------------------------- */
  /* 🔹 FETCH DIGITAL ORDERS */
  /* ---------------------------------- */

  const DigitalOrders = () => {
    setLoader(true);

    const UserJWTAuth = localStorage.getItem("UserJWTAuth");

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v1/digital/order/98F3ECBE2A284664`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: (res) => {
        setLoader(false);
        setDigitalOrderData(res?.data?.data);
      },
      handleError: () => {
        setLoader(false);
      },
    });
  };

  /* ---------------------------------- */
  /* 🔹 CLAIM DIGITAL ORDER */
  /* ---------------------------------- */

  const ClaimdigitalOrder = (lineItemId) => {
    makeApiRequest({
      url: "https://api-prod.daalchini.co.in/consumerbe/api/v1/digital/claim",
      method: "POST",
      data: {
        itemId: lineItemId,
      },
      headers: {
        accept: "application/json, text/plain, */*",
        "content-type": "application/json",
        "x-device-id": localStorage.getItem("uuid") || "",
      },
      handleSuccess: (res) => {
        // ✅ On Success → navigate with query params
        navigate(`/ClaimSuccess?claim=true&lineitemid=${lineItemId}`);
      },
      handleError: (err) => {
        //console.log("Claim Error", err);
        setClaimFlag(false)
      },
    });
  };

  /* ---------------------------------- */
  /* 🔹 CONDITIONAL RENDER */
  /* ---------------------------------- */

  if (claimedFlag) {
    return <ClaimSuccess lineitemid={lineitemid} />;
  }

  return (
    <Cliam
      digitalorderData={digitalorderData}
      ClaimdigitalOrder={ClaimdigitalOrder}
    />
  );
};

export default AuthConsider;